import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ThemePalette} from '@angular/material/core/common-behaviors/color';

export interface MultiActionItem {
  label: string;
  action: string;
  icon?: string;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  @Input() label: string | undefined;
  @Input() destructive = false;
  @Input() disabled = false;
  @Input() link = false;

  @Input() multiAction = false;
  @Input() multiActionFooter = false;
  @Input() actions?: MultiActionItem[];

  @Input() color: ThemePalette = 'primary';
  @Input() secondary = false;

  @Input() icon: string | undefined;

  @Input() routerLink: string | undefined;
  @Input() href: string | undefined;
  @Input() target = '_blank';

  @Input() width: string = 'auto';

  @Output() clicked = new EventEmitter<MouseEvent>();
  @Output() actionClicked = new EventEmitter<string>();

  click($event: MouseEvent) {
    this.clicked.emit($event);
  }

  actionClick(action: MultiActionItem) {
    this.actionClicked.emit(action.action);
  }
}
